import createIcon from '../../createIcon';

/**
 * @component @name OndemandVideo
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEgM0gzQzEuODkgMyAxIDMuODkgMSA1VjE3QzEgMTguMSAxLjg5IDE5IDMgMTlIOFYyMUgxNlYxOUgyMUMyMi4xIDE5IDIyLjk5IDE4LjEgMjIuOTkgMTdMMjMgNUMyMyAzLjg5IDIyLjEgMyAyMSAzWk0yMSAxN0gzVjVIMjFWMTdaTTE2IDExTDkgMTVWN0wxNiAxMVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const OndemandVideo = createIcon('OndemandVideo', [
  [
    'path',
    {
      d: 'M21 3H3C1.89 3 1 3.89 1 5V17C1 18.1 1.89 19 3 19H8V21H16V19H21C22.1 19 22.99 18.1 22.99 17L23 5C23 3.89 22.1 3 21 3ZM21 17H3V5H21V17ZM16 11L9 15V7L16 11Z',
      key: 'art5bx',
    },
  ],
]);

export default OndemandVideo;
